/* Preparation dialogs use local markup: no remote request on open or reopen. */
(() => {
  if (window.holyRecipePopupsReady) return;
  window.holyRecipePopupsReady = true;
  let active = null;
  let opener = null;
  let savedScroll = null;
  const pause = root => root.querySelectorAll('video').forEach(video => video.pause());

  function unlock() {
    if (!savedScroll) return;
    const saved = savedScroll;
    savedScroll = null;
    Object.entries(saved.styles).forEach(([property, value]) => {
      document.body.style[property] = value;
    });
    document.documentElement.classList.remove('hor-lock');
    window.scrollTo({ top: saved.y, left: saved.x, behavior: 'instant' });
  }

  function close(dialog) {
    pause(dialog);
    if (dialog.open) dialog.close();
    if (active !== dialog) return;
    active = null;
    unlock();
    if (opener?.isConnected) opener.focus({ preventScroll: true });
    opener = null;
  }

  function open(dialog, trigger) {
    if (active === dialog && dialog.open) return;
    if (active) close(active);
    init();
    opener = trigger;
    active = dialog;
    savedScroll = { x: window.scrollX, y: window.scrollY, styles: {} };
    ['position', 'top', 'left', 'width', 'overflow'].forEach(property => {
      savedScroll.styles[property] = document.body.style[property];
    });
    Object.assign(document.body.style, {
      position: 'fixed', top: `-${savedScroll.y}px`, left: `-${savedScroll.x}px`,
      width: '100%', overflow: 'hidden'
    });
    document.documentElement.classList.add('hor-lock');
    dialog.showModal();
    dialog.scrollTop = 0;
    dialog.querySelector('[data-hor-close]').focus({ preventScroll: true });
  }

  function selectTab(tab) {
    const area = tab.closest('.hor-video-area');
    pause(area);
    area.querySelectorAll('[role="tab"]').forEach(item => {
      const selected = item === tab;
      item.setAttribute('aria-selected', String(selected));
      item.tabIndex = selected ? 0 : -1;
      const panel = document.getElementById(item.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });
  }

  function init() {
    document.querySelectorAll('[data-hor-open]').forEach(link => {
      const dialog = [...document.querySelectorAll('[data-hor-dialog]')]
        .find(item => item.dataset.horDialog === link.dataset.horOpen);
      if (dialog && typeof dialog.showModal === 'function') link.setAttribute('aria-haspopup', 'dialog');
    });
    document.querySelectorAll('[data-hor-dialog]:not([data-hor-ready])').forEach(dialog => {
      dialog.dataset.horReady = 'true';
      dialog.addEventListener('cancel', event => { event.preventDefault(); close(dialog); });
      dialog.addEventListener('close', () => { if (!dialog.open) close(dialog); });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close(dialog);
      });
      // Only one preparation video should play at a time.
      dialog.addEventListener('play', event => {
        dialog.querySelectorAll('video').forEach(video => { if (video !== event.target) video.pause(); });
      }, true);
    });
  }

  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-hor-open]');
    if (trigger && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
      const dialog = [...document.querySelectorAll('[data-hor-dialog]')]
        .find(item => item.dataset.horDialog === trigger.dataset.horOpen);
      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        open(dialog, trigger);
      }
      return;
    }
    const exit = event.target.closest('[data-hor-close]');
    if (exit) { close(exit.closest('dialog')); return; }
    const tab = event.target.closest('.hor-dialog .hor-tabs [role="tab"]');
    if (tab) { selectTab(tab); return; }
    const jump = event.target.closest('.hor-dialog .hor-guide-nav a');
    if (jump) {
      const target = document.getElementById(jump.hash.slice(1));
      if (target && active?.contains(target)) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'instant', block: 'start' });
        target.tabIndex = -1;
        target.focus({ preventScroll: true });
      }
    }
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('.hor-dialog .hor-tabs [role="tab"]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const tabs = [...tab.parentElement.querySelectorAll('[role="tab"]')];
    let index = tabs.indexOf(tab);
    index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 :
      (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    selectTab(tabs[index]);
    tabs[index].focus();
  });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    if (active && event.target.contains(active)) close(active);
  });
  document.addEventListener('shopify:section:select', event => {
    const dialog = event.target.querySelector('[data-hor-dialog]');
    if (dialog) open(dialog, null);
  });
  document.addEventListener('shopify:block:select', event => {
    const dialog = event.target.closest('[data-hor-dialog]');
    if (dialog) {
      open(dialog, null);
      const panel = event.target.closest('[role="tabpanel"]');
      if (panel) selectTab(document.getElementById(panel.getAttribute('aria-labelledby')));
      event.target.scrollIntoView({ block: 'center' });
    }
  });
  document.addEventListener('visibilitychange', () => { if (document.hidden && active) pause(active); });
  init();
})();
